import Vue from 'vue'
import Tooltip from '~/components/ui/UiTooltip'

export default {
  inserted: (el, binding) => {
    if (!binding.value || !binding.value.text || !binding.value.text.trim()) {
      return
    }

    let isShow = false
    let tooltip

    const setPosition = (elTooltip) => {
      const contentTooltip = elTooltip.querySelector('.js-tooltip')
      const rectTooltip = contentTooltip.getBoundingClientRect()
      const windowWidth = window.innerWidth

      if (rectTooltip.left < 2) {
        contentTooltip.classList.add('left')
      }
      else if (windowWidth - rectTooltip.right < 2) {
        contentTooltip.classList.add('right')
      }

      if (rectTooltip.top < 2) {
        elTooltip.classList.add('bottom')
      }
    }

    const createComponent = (el, binding) => {
      const vm = new Vue({
        render: h => h(Tooltip, {
          props: {
            title: binding.value.title,
            text: binding.value.text,
            theme: binding.value.theme,
            top: binding.value.top,
            bottom: binding.value.bottom,
            right: binding.value.right,
            left: binding.value.left,
            rightPosition: binding.value.rightPosition,
            width: binding.value.width,
            timeOut: binding.value.timeOut,
          },
        }),
      }).$mount()

      const eventStatus = binding.value.eventStatus
      eventStatus && eventStatus(true)

      vm.$el.eventStatus = eventStatus

      el.append(vm.$el)
      setPosition(vm.$el)

      return vm.$el
    }

    const showTooltip = () => {
      if (isShow) return
      tooltip = createComponent(el, binding)
      isShow = true

      if (binding.value.timeOut) {
        setTimeout(() => {
          hideTooltip()
        }, binding.value.timeOut)
      }
    }

    const hideTooltip = () => {
      if (!isShow || !tooltip) return
      tooltip.classList.add('remove')

      setTimeout(() => {
        tooltip.eventStatus && tooltip.eventStatus(false)
        tooltip?.remove()
        isShow = false
      }, 400)
    }

    function eventHandler(e) {
      hideTooltip(e)
    }

    const trigger = binding.value.trigger || 'click'

    if (trigger === 'click') {
      el.addEventListener('click', (e) => {
        e.stopPropagation()
        if (!isShow) {
          showTooltip()
          document.addEventListener('click', eventHandler, true)
        }
        else {
          hideTooltip()
        }
      })
    }
    else if (trigger === 'hover') {
      el.addEventListener('mouseenter', showTooltip)
      el.addEventListener('mouseleave', hideTooltip)
    }
  },
}
